import moment from "moment";
import { InputSwitch } from "primereact/inputswitch";
import React, { Fragment, useContext } from "react";
import { TIME_ZONE } from "../../../../constants";
import { useMutation } from "react-query";
import { IsLoadingResponse } from "../../../../utils/Helper";
import DataTabel from "../../../../reuseable/DataTabel";
import { TABEL_UNIQUE_ID } from "../../../../constants/RoutingConstants/RoutingConstants";
import SweetConfirmation from "../../../../reuseable/sweetConfirmation";
import {
  deleteLanguageMaster,
  enableDisableLanguageMaster,
  getDetailsLanguageMaster,
} from "../../../../Apis/LanguageMasterApi/LanguageMasterApi";
import LanguageContext from "../../../../context/LanguageContext/LanguageContext";
import Actions from "../../../../layouts/Actions";

const LanguageDataTabelContainer = (props) => {
  const {
    filter,
    setFilter,
    record,
    pageSize,
    page,
    setPageSize,
    setPage,
    setFormData,
    setdialogs,
    setOrgId,
    setIsEdit,
    setSortBy,
    setSortOrder,
    sortOrder,
  } = useContext(LanguageContext);
  const { isLoading, data, handleOpenandClosePopup, refetch } = props;

  /**
   * get Language Details
   */
  const { mutate: LanguageDetails_, isLoading: isLoadingLanguageDetails } =
    useMutation((languageId) =>
      getDetailsLanguageMaster(languageId, setFormData, setdialogs)
    );

  const LanguageDetails = (languageId) => {
    LanguageDetails_(languageId);
    setOrgId(languageId);
    setIsEdit(false);
  };

  /**
   * delete Language
   */
  const { mutate: LanguageDelete, isLoading: isLoadingDelete } = useMutation(
    (languageId) => deleteLanguageMaster(languageId, refetch)
  );

  const DeleteLanguage = async (languageId) => {
    SweetConfirmation(LanguageDelete, languageId);
  };

  /**
   * enable / disable Language
   */

  const { mutate: statusChangeMutate } = useMutation((formData) =>
    enableDisableLanguageMaster(formData, refetch)
  );

  const handleLanguageStatusChange = (languageId, status) => {
    let formDate = {
      languageId: languageId,
      isActive: status ? false : true,
    };

    data.payload.data = data.payload.data.map((row) => {
      if (row.languageId === languageId) {
        return {
          ...row,
          isActive: status ? false : true,
        };
      } else {
        return row;
      }
    });
    statusChangeMutate(formDate);
  };

  /**
   *
   * @param {Sorting obj} col
   * Table Sorting
   */

  const sorting = (col) => {
    if (sortOrder === "") {
      let found = col.find((obj) => {
        return obj.field;
      });
      setSortBy(found.field);
      setSortOrder("ASC");
    }
    if (sortOrder === "ASC") {
      let found = col.find((obj) => {
        return obj.field;
      });
      setSortBy(found.field);
      setSortOrder("DSC");
    }
    if (sortOrder === "DSC") {
      setSortBy();
      setSortOrder("");
    }
  };

  const defaultColumns = [
    {
      flex: 0.1,
      minWidth: 180,
      field: "name",
      headerName: "Name",
      renderCell: (params) => (params.row.name ? params.row.name : "--"),
    },
    {
      flex: 0.1,
      minWidth: 100,
      field: "status",
      headerName: "Status",
      renderCell: (params, index) => (
        <div className="flex justify-content-center">
          <InputSwitch
            checked={params.row.isActive === true}
            onChange={() =>
              handleLanguageStatusChange(
                params.row.languageId,
                params.row.isActive
              )
            }
          />
        </div>
      ),
    },
    {
      flex: 0.1,
      minWidth: 180,
      field: "createdAt",
      headerName: "CreatedAt",
      sortable: false,
      renderCell: (params) =>
        moment(params.row.createdAt)
          .utcOffset(TIME_ZONE)
          .format("DD MMM, YYYY hh:mm"),
    },
    {
      flex: 0.1,
      minWidth: 100,
      field: "actions",
      headerName: "Actions",
      sortable: false,

      renderCell: (params) => (
        <>
          <Actions
            id={params.row.languageId}
            getDetails={LanguageDetails}
            deleteDetails={DeleteLanguage}
          />
        </>
      ),
    },
  ];
  return (
    <Fragment>
      <IsLoadingResponse
        isLoading={isLoadingLanguageDetails || isLoadingDelete}
      />
      <DataTabel
        filter={filter}
        setFilter={setFilter}
        handleOpenandClosePopup={handleOpenandClosePopup}
        data={data}
        defaultColumns={defaultColumns}
        record={record}
        pageSize={pageSize}
        page={page}
        setPageSize={setPageSize}
        setPage={setPage}
        sorting={sorting}
        isLoading={isLoading}
        sortOrder={sortOrder}
        setSortBy={setSortBy}
        setSortOrder={setSortOrder}
        id={TABEL_UNIQUE_ID.languageId}
        addButton={true}
      />
    </Fragment>
  );
};

export default LanguageDataTabelContainer;
